import { render } from "./UpdateSparkKzCompany.vue?vue&type=template&id=98069246&scoped=true&ts=true"
import script from "./UpdateSparkKzCompany.vue?vue&type=script&lang=ts"
export * from "./UpdateSparkKzCompany.vue?vue&type=script&lang=ts"

import "./UpdateSparkKzCompany.vue?vue&type=style&index=0&id=98069246&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98069246"]])

export default __exports__